<div style="position:fixed; z-index:9999; top:0px;left:0;height:100%;width:100%;background:rgba(0, 0, 0, 0.8)">
  <div class="well clearfix" style="position:relative; margin:0 auto; top:10px; height: 500; width:300px;">
    <div class="row">
      <div class="col-xs-12">
        <label>{{ 'weblink.edit.status' | translate }}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <input type="text" class="form-control" name="status" readonly [(ngModel)]="statusText" >
      </div>
    </div>
    <div class="row margin-top">
        <div class="col-xs-12">
          <label>{{ 'weblink.edit.date' | translate }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
            <input type="text" class="form-control" name="status" readonly [(ngModel)]="statusDate" >
        </div>
      </div>
  
    <div class="row margin-top">
      <div class="col-xs-12">
        <label>{{ 'weblink.edit.remarks' | translate }}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <textarea readonly maxlength="4000" name="text" [rows]="windowSize=='xs'?3:5" class="form-control" placeholder="{{ 'weblink.edit.remarks' | translate }}" style="resize: none;" [(ngModel)]="activity.Description" ></textarea>
      </div>
    </div>
    <div class="row double-margin-top">
      <div class="col-xs-12">
        <button type="button" class="btn btn-default" (click)="close()">
            <span class="glyphicon glyphicon-remove"></span>
            {{ 'general.button.close' | translate }} <span class="badge"></span>
        </button>
      </div>
    </div>

  </div>
</div>
